import { Column, Entity, Index } from 'typeorm';
import type { ImportColumnMappingModel } from '../import/import-run.models';
import { BaseEntity } from './base.entity';

/**
 * A named, reusable column mapping for one importer (PD-12353). Applying a
 * profile to a file whose headers have drifted (renamed / added / missing
 * columns) goes through reconciliation in the mapping step — never a silent
 * partial apply. Name uniqueness per importer is enforced in the service
 * (soft-deletes make a DB unique key impractical here).
 */
@Index('idx_import_mapping_profile_key', ['importerKey'])
@Entity('import_mapping_profile')
export class ImportMappingProfileEntity extends BaseEntity {
	/** Which importer this profile belongs to (e.g. 'client'). */
	@Column('varchar', { name: 'importerKey', length: 100 })
	public importerKey!: string;

	@Column('varchar', { name: 'name', length: 255 })
	public name!: string;

	@Column('json', { name: 'mapping' })
	public mapping!: ImportColumnMappingModel;

	@Column('datetime', { name: 'lastUsedDate', nullable: true })
	public lastUsedDate!: Date | null;
}
